var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavePencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2583 5.86667C17.5833 5.54167 17.5833 5.00001 17.2583 4.69167L15.3083 2.74167C15 2.41667 14.4583 2.41667 14.1333 2.74167L12.6 4.26667L15.725 7.39167M2.5 14.375V17.5H5.625L14.8417 8.27501L11.7167 5.15001L2.5 14.375Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavePencilIcon);
export default __webpack_public_path__ + "static/media/savePencilIcon.62056eee29f05f78abea2f07ace6c3db.svg";
export { ForwardRef as ReactComponent };